import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import CheckBoxOutlineBlankTwoToneIcon from '@material-ui/icons/CheckBoxOutlineBlankTwoTone';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import SurveyQuestionContext from '../../../context/surveyquestion-context';
import useStyles from "../../../styles/components/survey/stylesSurveyQuestionContainer";


const CheckboxQuestionHolder = ({ index }) => {
    const classes = useStyles();
    const { surveyQuestionContext, dispatch } = useContext(SurveyQuestionContext);
    const position = index - (surveyQuestionContext.scaleContents.length + surveyQuestionContext.multipleChoiceContents.length + surveyQuestionContext.rankingContents.length)
    
    const handleChange = (answer, content, index) => event => {
        let size = content.checkboxAnswerDictionary.length;
        let limit = content.seletionLimit;
        if (answer.isChecked) {
            answer.isChecked = false
            content.checkboxAnswerDictionary = content.checkboxAnswerDictionary.filter(item => item.id !== answer.id)
        }
        else if (size < limit || limit <= 0) {
            answer.isChecked = true
            content.checkboxAnswerDictionary = [...content.checkboxAnswerDictionary, answer]
        }
        dispatch({ type: 'SET_CHECKBOX_CONTENTS', checkboxContents: surveyQuestionContext.checkboxContents });
    };
    
    return (
        <div>
            {surveyQuestionContext.checkboxContents.length > 0 &&
                <>
                    <Typography variant='h6' className={clsx(classes.rootTypographyQuestion, classes.typographyDown)}>{surveyQuestionContext.checkboxContents[position].question.questionContent}</Typography>
                    <Grid item xs={12} sm={12}>
                        <FormControl component="fieldset">
                            {surveyQuestionContext.checkboxContents[position].answers.map((answer, index) => (
                                    <FormGroup key={index}>
                                        <FormControlLabel
                                            control={<Checkbox icon={<CheckBoxOutlineBlankTwoToneIcon classes={{ root: classes.checkbox }} />} checkedIcon={<CheckBoxOutlinedIcon />} checked={answer.isChecked} onChange={handleChange(answer, surveyQuestionContext.checkboxContents[position], index)} value={answer.questionOptionContent} />}
                                            label={answer.questionOptionContent}
                                            classes={{label: classes.typographyDown}}
                                        />
                                    </FormGroup>
                                ))
                            }
                        </FormControl>
                    </Grid>
                </>
            }
        </div >
    )
}

export default CheckboxQuestionHolder;